<template>
  <div class="registration scrollable-div">
    <div class="header">
      <div class="header">
        <div class="col align-self-center">
          <Logo/>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row content">
        <div class="col align-self-center">
          <div class="row header text-center">
            <div class="col align-self-center">
              <h2>{{ $t('registration.h2') }}</h2>
            </div>
          </div>
          <div class="row main">
            <form @submit.prevent="onSubmit" class="form">
              <div class="form-group " :class="{ 'invalid': form.data.name !== null &&
                            $v.form.data.name.$invalid }">
                <label for="last_name">
                  {{ $t('registration.full_name') }}
                </label>
                <input id="last_name" type="text" class="form-control" v-model="form.data.name"
                       placeholder="ПІБ українською мовою">
                <span class="error-message" v-if="form.data.name !== null &&
                            $v.form.data.name.$invalid">{{ $t('registration.full_name_not_entered') }}</span>
              </div>

              <div class="form-group"
                   :class="{ 'invalid': form.data.birthday !== null && $v.form.data.birthday.$invalid }">
                <label>
                  {{ $t('registration.birthday_date') }}
                </label>
                <date-input id="birthday" v-model="form.data.birthday"></date-input>
              </div>
              <div class="form-group">
                <label for="sex">
                  {{ $t('registration.sex') }}
                </label>
                <v-select id="sex"
                          v-model="form.data.sex"
                          :options="sexes"
                          :searchable="false"
                          class="sexSelect"
                          label="label">
                </v-select>
              </div>
              <div class="form-group "
                   :class="{ 'invalid': form.data.password !== null && $v.form.data.password.$invalid }">
                <label for="password">
                  {{ $t('registration.password') }}
                </label>
                <input id="password" type="password" class="form-control" v-model="form.data.password">
                <div style="font-size: 12px;line-height: 15px;">
                  <span class="required">* &nbsp;</span>{{ $t('registration.pass_length') }}
                </div>
              </div>
              <div v-if="form.errors.generic_error" class="alert alert-info" role="alert">
                {{ $t('registration.generic_error') }}
              </div>
              <div v-if="form.errors.duplicate_phone_number_error" class="alert alert-info" role="alert">
                {{ $t('registration.user_already_created_by_phone') }}
              </div>
              <div v-if="form.errors.duplicate_email_error" class="alert alert-info" role="alert">
                {{ $t('registration.email_exist') }}
              </div>
              <div v-if="form.errors.sending_registration_email_error" class="alert alert-info"
                   role="alert">
                {{ $t('registration.send_error') }} {{ $t('registration.try_again_leter') }}
              </div>
              <div v-if="form.errors.user_with_primary_patient_already_exists_exception" class="alert alert-info"
                   role="alert">
                {{ $t('registration.user_account_with_primary_patient_already_exist', {number: form.errors.user_with_primary_patient_already_exists_exception}) }}
                <br/>
                {{ $t('registration.call_to_support') }}
              </div>
              <div v-if="form.errors.phone_format_error" class="alert alert-info" role="alert">
                {{ $t('registration.phone_invalide') }}
              </div>
              <div v-if="form.data.birthday !== null && $v.form.data.birthday.$invalid" class="alert alert-info w-100"
                   role="alert">
                {{ $t('registration.older_then_18') }} <a href="https://odrex.ua/ua/app/" target="_blank" rel="noopener"><b>{{ $t('buttons.details') }}</b></a>.
              </div>
              <div v-if=" $v.form.$invalid && validationErrors.length > 0"
                   class="alert alert-info w-100 validation-errors" role="alert">
                <ul class="mb-0">
                  <li :class="{'list-disc' : validationErrors.length > 1}" v-for="message in validationErrors">
                    {{ message }}
                  </li>
                </ul>
              </div>
              <button type="submit" class="btn btn-primary" :disabled="$v.$invalid || form.sending">
                {{ $t('registration.registration') }}
              </button>
            </form>

          </div>
        </div>
      </div>
    </div>
    <LimitErrorModal v-if="limitErrorModalShow"/>
    <div v-if="limitErrorModalShow" class="overlay"></div>
  </div>
</template>
<script>
import {minLength, maxLength, email, sameAs, required} from 'vuelidate/lib/validators';

import moment from 'moment';
import Logo from '../components/Logo';
import PhoneInput from '../components/PhoneInput';
import DateInput from '../components/DateInput';
import LimitErrorModal from "../components/LimitErrorModal";

const validationAdultRule = (value) => moment().diff(moment(value, 'm.d.Y'), 'years') >= 18;

export default {
  mounted() {
    if (this.$store.getters.getPhone === null) {
      this.$router.push({name: 'registration'})
    }
  },
  data() {
    let sexes = [
      {'id': 'MAL', 'label': 'Чоловік'},
      {'id': 'FEM', 'label': 'Жінка'},
    ];
    return {
      form: {
        data: {
          name: null,
          birthday: null,
          phone: null,
          password: null,
          sex: sexes[0],
        },
        errors: {
          duplicate_phone_number_error: false,
          sending_registration_email_error: false,
          phone_format_error: false,
          user_with_primary_patient_already_exists_exception: null,
        },
        sending: false,
      },
      sexes,
      validationErrors: []

    };
  },
  computed: {
    limitErrorModalShow() {
      return this.$store.getters.limitError;
    },
    doctors() {
      return this.$store.getters.doctors;
    }
  },
  validations() {
    const onlyTextRegexp = /^([а-яА-ЯёЁіIїЇґҐєЄ\s-]+) ([а-яА-ЯёЁіIїЇґҐєЄ\s-]+) ([а-яА-ЯёЁіIїЇґҐєЄ\s-]+)$/i;
    return {
      form: {
        data: {
          name: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(80),
            onlyText(value) {
              return onlyTextRegexp.test(value);
            },

          },
          birthday: {
            required,
            validationAdultRule

          },
          password: {
            required,
            minLength: minLength(8),
          },
        },
      },
    };
  },
  methods: {
    onSubmit() {
      this.form.errors = {
        duplicate_phone_number_error: false,
        duplicate_email_error: false,
        sending_registration_email_error: false,
        user_with_primary_patient_already_exists_exception: false,
        phone_format_error: false,
        generic_error: false,
      };

      this.form.sending = true;

      const {birthday, sex, password} = this.form.data;

      let requestData = {
        name: this.form.data.name,
        birthday: moment(birthday).format('DD.MM.YYYY'),
        sex: sex.id,
        phone: this.$store.getters.getPhone.replace(/[-()\+]/g, ''),
        password,
      };

      this.$store.dispatch('registerUser', requestData).then(({data}) => {
        this.$router.push({name: 'registration.success', params: {type: 'registration'}})
      }).catch((error) => {
        this.form.errors.generic_error = true;

        if (error.response.data.code === 'user-with-primary-patient-already-exists-exception') {
          this.form.errors.user_with_primary_patient_already_exists_exception = error.response.data.context.phone
          this.form.errors.generic_error = false;
        }

        if (error.response.data.errors.phone) {
          this.form.errors.duplicate_phone_number_error = true
          this.form.errors.generic_error = false;
        }

        if (error.response.data.errors) {
          this.validationErrors = Object.values(error.response.data.errors)
              .flatMap(errors => errors);

          if(this.validationErrors.length > 0){
            this.form.errors.generic_error = false;
          }

        }
      })


    }
  },
  beforeMount() {
    this.$i18n.locale = 'ua';
  },
  components: {
    Logo,
    DateInput,
    PhoneInput,
    LimitErrorModal
  }
  ,
}
</script>
<style lang="scss">
@import "../assets/scss/utils/variables";

.error-message {
  color: red;
  font-size: 14px;
  line-height: 25px;
}

.sexSelect {
  background: #ffffff;

  .dropdown-toggle {
    height: 50px;
    border: 1px solid #d1e0e7 !important;
    box-shadow: 0 2px 4px -1px rgba(163, 190, 204, 0.5) !important;
  }

  .selected-tag {
    color: $font-color;
    height: 50px;
    font-size: 18px;
    line-height: 49px;
    margin: 0;
    padding: 0 0 0 15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    pointer-events: none;
  }

  .clear {
    display: none;
  }

  &.open .open-indicator {
    bottom: 10px;
  }

  .open-indicator {
    bottom: 16px;
    right: 20px;

    &::before {
      height: 13px;
      width: 13px;
      border-width: 2px 2px 0 0;
      border-color: $link-shadow;
    }
  }

  li {
    &.highlight > a,
    &:hover {
      background: $button-color !important;
    }

    a {
      padding: 10px 15px !important;
    }
  }
}

.validation-errors {
  li {
    &.list-disc {
      list-style: disc;
      color: white;
    }
  }
}


</style>
